<template>
  <div>
    <NuxtImg
      src="/zuno-logo.png"
      width="40"
      height="40"
      alt="Veridis Logo"
      title="Veridis Logo"
    />
  </div>
</template>

<script>
export default {
  name: 'VeridisLogo',
}
</script>
